import { useEffect } from "react";
import { Link } from "react-router-dom";
import { PHOTOS } from "../lib/constants";
import SEO from "../components/SEO";

const QUICK_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function NotFoundPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div data-testid="not-found-page" className="nf-root">
      <SEO
        title="Page Not Found — Tulsi Giri"
        description="The page you're looking for doesn't exist."
        path="/404"
      />

      {/* Content */}
      <div className="nf-content" data-testid="not-found-content">
        {/* 404 watermark */}
        <p className="nf-watermark" aria-hidden="true" data-testid="not-found-watermark">404</p>

        {/* Portrait */}
        <div className="nf-portrait-wrap nf-fade nf-fade-1" data-testid="not-found-portrait">
          <img src={PHOTOS.formal} alt="Tulsi Giri" className="nf-portrait" />
        </div>

        {/* Heading */}
        <h1 className="nf-heading nf-fade nf-fade-2" data-testid="not-found-heading">
          This page wandered off the path.
        </h1>

        {/* Sub */}
        <p className="nf-sub nf-fade nf-fade-3" data-testid="not-found-subtext">
          The page you're looking for doesn't exist or has moved.
        </p>

        {/* 2x2 Quick-link grid */}
        <nav className="nf-grid" data-testid="not-found-links">
          {QUICK_LINKS.map((link, i) => (
            <Link
              key={link.to}
              to={link.to}
              className={`nf-card nf-fade nf-fade-card-${i + 1}`}
              data-testid={`not-found-link-${link.label.toLowerCase()}`}
            >
              <span className="nf-card-arrow">&rarr;</span> {link.label}
            </Link>
          ))}
        </nav>

        {/* Signature */}
        <p className="nf-sig nf-fade nf-fade-sig" data-testid="not-found-signature">— Tulsi</p>
      </div>
    </div>
  );
}
